<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-skeleton-img v-bind="$attrs" />
    </template>
    <slot></slot>
  </b-skeleton-wrapper>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AdSkeletonImage extends Vue {
  @Prop({ default: true, type: Boolean, required: true }) loading;
}
</script>
